/**
 * Módulo: Consultoría (Marketplace)
 * Perfiles de consultores, contratación, sesiones, rating.
 * FASE 3 — construido pero deshabilitado hasta que se abra el marketplace.
 */
export default {
  id: 'consultoria',
  nombre: 'Consultoría',
  descripcion: 'Marketplace de consultores certificados',
  icono: 'award',
  tipo: 'marketplace',
  version: '0.1.0',
  // Fase 3 — cuando se habilite será visible para todos

  routes: [
    // Se agregarán en Sesión 7: MarketplacePage, ConsultorProfilePage
  ],

  menuItems: [
    // Se agregarán cuando se habilite el marketplace
  ],

  features: [
    'marketplace-consultores',
    'sesiones-consultoria',
    'rating-consultores',
    'certificacion',
  ],

  // permisoModulos (#58): se deriva del rol.
  permisoModulos: ['consultoria'],


  // Flag: este módulo no se activa hasta Fase 3
  habilitadoPorDefault: false,
}
